export default {
  banner: {
    slogan: {
      part1: '生产一种产品 推动一种进步',
      part2: '释放一种能量 改变一次世界'
    }
  },
  accordion: {
    learnMore: "了解更多",
    items: {
      company: {
        title: "关于公司",
        content:
          "上海超导是一家专注于高温超导材料的研发、生产和销售的高新技术企业。上海超导致力于成为全球超导领域的领跑者，目前已成长为全球第二代高温超导材料的核心供应商之一。",
      },
      applications: {
        title: "应用场景",
        content:
          "公司核心业务涵盖高温超导带材及相关技术服务，产品广泛应用于可控核聚变、超导电力、高场磁体等前沿科技领域。",
      },
      products: {
        title: "产品与技术服务",
        content:
          "公司主要产品为第二代高温超导带材，突破了上、中、下游产业链、同时为客户提供全套优质产品，是国际上能够批量年产并销售千公里以上高温超导带材的生产商之一。",
      },
      news: {
        title: "公司动态",
        content: "公司新闻、行业动态、技术进展等最新资讯。",
      },
      contact: {
        title: "联系我们",
        content: "联系我们获取更多信息。",
      },
    },
  },
  company: {
    items: {
      introduction: {
        title: "公司介绍",
        content: "",
      },
      dream: {
        title: "愿景和使命",
        content: "",
      },
      chronicle: {
        title: "公司大事记",
        content: "",
      },
      partners: {
        title: "合作伙伴",
        content: "",
      },
      honors: {
        title: "荣誉资质",
        content: "",
      },
      structure: {
        title: "下设机构",
        content: "",
      },
    },
  },
  contactinfo: {
    title: "联系我们",
    address: "地址：上海市浦东新区康威路781号",
    addressmobile: "上海市浦东新区康威路781号",

    phone: "电话：(总机) 021-50817399 (市场营销部) 021-64056173 (招聘) 021-50817399-8006",
    phonemobile1: "(总机) 021-50817399",
    phonemobile2: "(市场营销部) 021-64056173",
    phonemobile3: "(招聘) 021-50817399-8006",
    email: "邮箱：",
    sales: "(销售) sales@shsctec.com",
    hr: "(招聘) hr@shsctec.com",
    inquiry: "(咨询) inquiry@shsctec.com",
    inspection: "(反商业贿赂) inspection@shsctec.com",
    serviceAccount: "服务号",
    subscriptionAccount: "订阅号"
  },
  securityNotice: {
    title: "招聘提示",
    close: "关闭",
    content: "上海超导官方招聘信息仅通过公司官网、官方微信公众号及合作招聘平台发布，整个招聘流程中不存在要求求职者下载任何软件、App或系统的情况，请广大求职者注意甄别，谨防受骗。如有疑问请联系：021-50817399-8006，hr@shsctec.com",
    emailLabel: "如有疑问请联系：",
    phoneLabel: "电话：",
  },
};
